import React from 'react'
import { Route, Switch } from 'react-router-dom'
// 第一期先不做多语言，后期做再放开
import localeResources from '@/locales/resources'
import i18n from '@/i18n'

const router = ({ routes, wrap }) => {

  return (
    <Switch>
      { routes.map((item) => {
        const componentRender = (props) => {
          const { match, history } = props
          // 如果i18n的当前语言与url中的语言不符，则使用url中的语言或浏览器当前语言
          // if(i18n.language !== match.params.lang){
          //   let lang = 'en'
          //   // 如果当前url语言存在，且在语言配置列表中存在，则使用当前url中的语言，否则使用浏览器当前语言
          //   if (match.params.lang && Object.keys(localeResources).includes(match.params.lang)) {
          //     lang = match.params.lang
          //   } else if(navigator.language){
          //     lang = navigator.language.split('-')[0].toLowerCase()
          //   }
          //   i18n.changeLanguage(lang)
          //   history.push(match.path.replace(':lang?', lang))

          //   return;
          // }

          if (item.component) {
            const cProps = {
              ...props,
              routes: (item.routes && item.routes) || routes,
            }
            return <item.component {...cProps} />
          }
          return <></>
        }

        return (
          <Route
            key={item.name}
            path={item.path}
            // component= { router.component }
            exact={item.exact}
            strict={item.strict}
            render={componentRender}
          />
        )
      }) }
      </Switch>


  )
}

export default router
